import React, { useState, useEffect, useRef } from 'react';

import { Button } from "reactstrap";
import Footer from "../Footer/Footer";

import Select from 'react-select';

import Navbar from "../Navbar/Navbar";
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import './Forms.css';

import * as Hosts from '../../../Hosts';

import {
    set_language,
    reqGET,
    reqPOST,
    //repo_banner_link,
    passwordHash,
    //gerarPassword,
    content_language,
    pattern_email,

	obter_cidades_por_distrito,
	//obter_distrito_por_cidade,
	obter_distritos_pt,

    functionSendMail,

} from '../../../Utils';


import { language } from '../WEBContent/Language';
import Loader from '../../../loader';

import Swal from 'sweetalert2'

const RegisterFarmerForm = (props) => {

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    //const [, set_dados_config] = useState(null)
    //const dados_config = useRef({})

    const [districts, set_districts] = useState([])
    const [cities, set_cities] = useState([])

    // const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!#$%&/()=?*+';
    const [pwd, set_pwd] = useState('');

    const [/*is_password*/, set_is_password] = useState(false)
    const [new_password, set_new_password] = useState('')
    const [confirm_password, /*set_confirm_password*/] = useState('')
    const [isloading, setLoading] = useState(true);

    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

    /*const navbar_interface = {
        id: '',
        info: {},
        content: {
            childs: []
        }
    }
    
    const navbar = useRef(navbar_interface);*/

    const [, set_dados_content] = useState(null)

    const content_interface = {
        id: '',
        info: {},
        content: {}
    }
    const content = useRef(content_interface)

    // function generateString(length) {
    //     let result = ' ';
    //     const charactersLength = characters.length;
    //     for ( let i = 0; i < length; i++ ) {
    //         result += characters.charAt(Math.floor(Math.random() * charactersLength));
    //     }
    
    //     return result;
    // }

    useEffect(() => {

       /* let getConfig = async () => {

            await reqGET(`${Hosts.SIMCore_API}/web/settings/type/${Hosts.companycode}/settings`)
              .then(async res => {
        
                if(res.data.length > 0) {
                    set_dados_config(dados_config.current = res.data[0].info?.settings)
                    set_dados_config(content.current = {id: '', info: {type: 'farmer', layout: 'all'}, content: []})
                }
        
              })
              .catch(erro => console.log('Erro', erro))
    
            await reqGET(`${Hosts.SIMCore_API}/web/structure/${Hosts.companycode}/1`)
              .then(async res => {
                  for await (let v of res.data) {
                  // res.data.forEach((v) => {
                      if (v.info.principal === true) {
      
                          if (lang !== 'pt') {
                              for await (let cl of content_language) {
                              // content_language.forEach((cl) => {
                                  let x = 0
    
                                  if (cl.code === lang) {
      
                                      v.content.childs.forEach((el) => {
                                          if (el.id_content !== '') {
                                              if (el.children !== undefined) {
                                                  x = x - el.children.length
                                                  //for await (let el_c of el.children) {
                                                  el.children.forEach(async (el_c) => {
                                                      await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el_c.id_content}`)
                                                          .then(res_3 => {
                                                              if (res_3.data.length > 0) {
                                                                  if (res_3.data[0].info.language.length > 0) {
                                                                      if (res_3.data[0].info.language[cl.id] !== undefined && res_3.data[0].info.language[cl.id] !== null) {
                                                                          if (res_3.data[0].info.language[cl.id]['name'] !== '') {
                                                                              el_c.title = res_3.data[0].info.language[cl.id]['name'];
      
                                                                              x++
                                                                              if (v.content.childs.length === x) {
                                                                                  setRefresh(refresh => refresh + 1)
                                                                              }
                                                                          }
                                                                      }
                                                                  }
                                                                  else {
                                                                      x++
                                                                      if (v.content.childs.length === x) {
                                                                          setRefresh(refresh => refresh + 1)
                                                                      }
                                                                  }
                                                              }
                                                              else {
                                                                  x++
                                                                  if (v.content.childs.length === x) {
                                                                      setRefresh(refresh => refresh + 1)
                                                                  }
                                                              }
                                                          })
                                                  })
                                              }
      
                                              reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el.id_content}`)
                                                  .then(res_2 => {
                                                      if (res_2.data.length > 0) {
                                                          if (res_2.data[0].info.language.length > 0) {
                                                              if (res_2.data[0].info.language[cl.id] !== undefined && res_2.data[0].info.language[cl.id] !== null) {
                                                                  if (res_2.data[0].info.language[cl.id]['name'] !== '') {
                                                                      el.title = res_2.data[0].info.language[cl.id]['name'];
      
                                                                      x++
                                                                      if (v.content.childs.length === x) {
                                                                          setRefresh(refresh => refresh + 1)
                                                                      }
                                                                  }
                                                              }
                                                          }
                                                          else {
                                                              x++
                                                              if (v.content.childs.length === x) {
                                                                  setRefresh(refresh => refresh + 1)
                                                              }
                                                          }
                                                      }
                                                      else {
                                                          x++
                                                          if (v.content.childs.length === x) {
                                                              setRefresh(refresh => refresh + 1)
                                                          }
                                                      }
                                                  })
      
      
                                          }
                                          else {
                                              if (el['language'] !== undefined && el['language'] !== null) {
                                                  if (el.language[cl.id] !== undefined && el.language[cl.id]['title'] !== undefined && el.language[cl.id]['title'] !== '') {
                                                      el.title = el.language[cl.id]['title']
      
                                                      x++
                                                      if (v.content.childs.length === x) {
                                                          setRefresh(refresh => refresh + 1)
                                                      }
                                                  }
                                              }
                                          }
      
                                      })
      
                                  }
                              }
      
                          }
      
                          set_dados_config(navbar.current = v);
                      }
                  }
                  console.log('rota da estrutura navbar RegisterFarmer.js');
      
              })
              .catch(erro => console.log('ERROR', erro))
        }*/

        // set_pwd(gerarPassword());

        (async () => {
            //await getConfig()  
            await obter_distritos_pt(set_districts)
      
            setLoading(false)
        })()
        
        //obter_distritos_pt(set_districts)


        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
            set_dados_navbar(props.dados_navbar)
        }
    
        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados_config(props.dados_config)
        }

        set_dados_content(content.current = {id: '', info: {type: 'farmer', layout: 'all'}, content: []})

    }, [props, lang]);

    const [agree, setAgree] = useState(false);

    const checkboxHandler = () => {
        // if agree === true, it will be set to false
        // if agree === false, it will be set to true
        setAgree(!agree);
        // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (agree) => {
        //console.log('AGREE', agree)
        if (agree === true)
            return true
        else
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
    }

    const data_interface = {
        id: '',
        info: {
            companycode: Hosts.companycode,
            username: '',
            password: '',
            name: '',
            email: '',
            vat: '',
            rgpd: false,
            ativo: true,
            entity_type: '',
            observation: '',
            identificacao: {
                tipo_identificacao:	'',
                numero_identificacao:	'',
                validade_identificacao:	''
            },
            use_preferences: {
                language: 'PT'
            }
        },
        addresses: [{
            //village: '',
            city: '',
            district: '',
            //type: [],
            //region: '',
            country: '',
            //apartado: '',
            location: '',
            //place_birth: '',
            //contats: [],
            //principal: '',
            //observation: '',
            postal_code: '',
            address: '',
            //address_detail: '',
        }],
        contacts: [{
            email: '',
            phone: '',
    
            principal: 'true',
            //extensions: [],
            observation: '',
    
            //building_number: '',
            /*person_responsables: [{
                id: '',
                name: '',
                email: '',
                extensions: '',
                observation: '',
                mobile_phone: ''
            }],*/
        }],
        profile: { name: "Farmer" },
        notifications: []
    }

    const [, set_dados] = useState(null);
    const dados = useRef(data_interface);

    const [refresh, setRefresh] = useState(0);

    const check_entity_field = async (name, value) => {
		reqGET(`${Hosts.SIMCore_API}/entities/list/${Hosts.companycode}/*`)
			.then(res => {

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k[name] === value) {
						ja_existe = true
					}
				})

				if (ja_existe === false) {

					set_dados(dados.current.info['username'] = value)
                    //set_dados(dados.current.info['email'] = value)
			
                    setRefresh(r => r + 1)

				} else {
					set_dados(dados.current.info['username'] = '');
                    set_dados(dados.current.info['email'] = '');
					setRefresh(refresh + 1)
                    //console.log('aki aki');
                    Swal.fire({
                        title: (name === 'email' ? language[lang].contact_email : language[lang].username_email),
                        text: language[lang].username_error_message,
                        icon: 'error',
                        //showCancelButton: true,
                        confirmButtonColor: '#08396a',
                        //confirmButtonText: 'Tentar novamente',
                      })
                    //alert('Já existe um registo com este username.');
					/*confirmAlert({
						title: 'Aviso',
						message: 'Já existe um registo com este nickname.',
						buttons: [
							{
								label: 'Voltar',
								onClick: () => { 
									//set_dados(dados.current.info.username = '');
									//setRefresh(refresh + 1)
									return
								}
							},

						]
					})*/

					//console.log(ja_existe);
				}
			}
			)
	}

    const handle_change_info = (e) => {
        const { name, value } = e.target;

        //console.log('NAME: ', name)
        //console.log('VALUE: ', value)

        set_dados(dados.current.info[name] = value)

        if ((name === 'email') && value !== '') {
			
			check_entity_field('username', value)
            //set_dados(dados.current.info['username'] = value)
            //set_dados(dados.current.contacts[0]['email'] = value)
			
            //setRefresh(r => r + 1)
		}

        //console.log('Dados Current info:' + JSON.stringify(dados))
    }

    const handle_change_info_2 = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)

        set_dados(dados.current.contacts[0][name] = value)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current info 2:' + JSON.stringify(dados))
	}

    const handle_change_contacts = (e) => {
        const { name, value } = e.target;

        //console.log('NAME: ', name)
        //console.log('VALUE: ', value)

        set_dados(dados.current.contacts[0][name] = value)

        console.log('Dados Current info:' + JSON.stringify(dados))
    }

    const handle_change_addresses = (e) => {
        const { name, value } = e.target;

        //console.log('NAME: ', name)
        //console.log('VALUE: ', value)

        set_dados(dados.current.addresses[0][name] = value)

        console.log('Dados Current info:' + JSON.stringify(dados))

    }

    const handleSubmit = async e => {
        e.preventDefault();


        Swal.fire('Loading...')

        let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +';border:1px solid transparent;border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
                '<td align="left" class style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        '<h4>'+ language[lang].farmer_regist + '</h4>' +
                        '<span><b>'+ language[lang].name +':</b> <label>' + dados.current.info.name + '</label></span>' +
                        '<br/>'+
                        '<span"><b>Email: </b><label>' + dados.current.contacts[0].email + '</label></span>'+
                        '<br/>'+
                        /*'<span"><b>' + language[lang].phone_number + ':</b> <label>' + dados.current.contacts[0].phone + '</label></span>'+
                        '<br/>'+
                        '<span"><b>' + language[lang].nif + ':</b> <label>' + dados.current.info.vat + '</label></span>'+
                        '<br/>'+
                        '<span"><b>' + language[lang].district + ':</b> <label>' + dados.current.addresses[0].district + '</label></span>'+
                        '<br/>'+
                        '<span"><b>' + language[lang].city + ':</b> <label>' + dados.current.addresses[0].city + '</label></span>'+
                        '<br/>'+
                        '<span"><b>' + language[lang].location + ':</b> <label>' + dados.current.addresses[0].location + '</label></span>'+
                        '<br/>'+
                        '<br/>' +*/
                        '<h4>'+ language[lang].access_data +'</h4>'+
                        '<span><b>'+ language[lang].username +':</b> <label>' + dados.current.info.username + '</label></span>' +
                        '<br/>'+
                        '<span><b>'+ language[lang].password +':</b> <label>' + language[lang].registry_defined + '</label></span>' +
                        '<br/>'+
                    '</div>'+
                '</td>' +
            '</tr>' +
        '</table>'

        dados.current.info.password = passwordHash(pwd);
        
        reqPOST(`${Hosts.SIMCore_API}/entities`, dados.current)
            .then(async () => {   

                Swal.fire({
                    title: language[lang].form_trainee_register,
                    text: language[lang].regist_form_sucess_message,
                    icon: 'success',
                    //showCancelButton: true,
                    confirmButtonColor: '#08396a',
                    //confirmButtonText: 'Tentar novamente',
                })

                let sendFrom = Hosts.contactFrom
                let sendTo = [dados.current.contacts[0].email]
                let sendToCC = ['web.dev@assec.pt']
                let subject = language[lang].regist
                let content = mail_content
                let attachment = []

                await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)

                //alert('Registo efetuado com sucesso!\n\nConsulte os seus dados de acesso no email enviado.')
                set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                document.getElementById('agree').checked = false 
                //props.history.push(endpoints.list) 

            })
            .catch((error) => console.log(error) /*alert('Problema ao atualizar Registo!')*/)

    }

    const change_district = e => {
        set_cities([])

        obter_cidades_por_distrito(e.value, set_cities)

        set_dados(dados.current.addresses[0].city = '')
        set_dados(dados.current.addresses[0].district = e.value)
    }

    const change_city = e => {
        set_dados(dados.current.addresses[0].city = e.value)
    }
    
	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if(new_password === value) {
			set_is_password(true)

            set_pwd(value)
			//set_disabled(false)
		}
		else {
			Swal.fire('', language[lang].password_text, 'info')
			set_is_password(false)
			//set_disabled(true)
		}
	}

    return (
        isloading ?

            <Loader />

        :
            <>
                <Navbar dados_config={dados_config} dados_navbar={dados_navbar} />
                <Breadcrumb dados_config={dados_config} dados_navbar={dados_navbar} dados_content={content.current} />
                <main className="farmer-regist my-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 title-properties d-none">
                                <h1 className="titulo-pp">{language[lang].farmer_regist}</h1>
                            </div>
                            <div className='col-12 col-lg-10 mx-auto'>
                                <form onSubmit={handleSubmit} id="trainee_register_form">
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            {language[lang].read_terms_conditions}
                                        </div>
                                        <div className="col-12 mb-3">
                                            <h2 className='titulo-secundario'>{language[lang].farmer_data}</h2>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-12 col-md-6 mb-3">
                                            <label className="form-label" htmlFor="name">{language[lang].name}*</label>
                                            <input 
                                                id="name"
                                                type="text"
                                                name="name"
                                                value={dados.current.info.name}
                                                className="form-control"
                                                placeholder={language[lang].name_placeholder}
                                                onChange={handle_change_info}
                                                required
                                            />
                                        </div>
                                        <div className="col-12 col-md-4 mb-3 d-none">
                                            <label className="form-label" htmlFor="phone">{language[lang].phone_number}</label>
                                            <input
                                                id="phone"
                                                type="text"
                                                name="phone"
                                                className="form-control"
                                                placeholder={language[lang].phone_number_placeholder}
                                                value={dados.current.contacts[0].phone}
                                                onChange={handle_change_contacts} 
                                            />
                                        </div>
                                        <div className="col-12 col-md-4 mb-3 d-none">
                                            <label className="form-label" htmlFor="vat">{language[lang].nif}</label>
                                            <input
                                                id="vat"
                                                type="text"
                                                name="vat"
                                                className="form-control"
                                                placeholder={language[lang].nif_placeholder}
                                                value={dados.current.info.vat}
                                                onChange={handle_change_info} 
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-4 mb-3 d-none">
                                            <label className="form-label" htmlFor="vat">{language[lang].district}</label>
                                            <Select
                                                id="distrito"
                                                className="div-select"
                                                options={districts}
                                                name="distrito"
                                                value={dados.current.addresses[0].district === '' ? null : { label: dados.current.addresses[0].district, value: dados.current.addresses[0].district }}
                                                placeholder={language[lang].choose_district}
                                                onChange={change_district}
                                            /> 
                                        </div>
                                        <div className="col-12 col-md-4 mb-3 d-none">
                                            <label className="form-label" htmlFor="city">{language[lang].city}</label>
                                            <Select
                                                id="city"
                                                className="div-select"
                                                options={cities}
                                                name="city"
                                                value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
                                                placeholder={language[lang].choose_city}
                                                onChange={change_city}
                                            /> 
                                        </div>
                                        <div className="col-12 col-md-4 mb-3 d-none">
                                            <label className="form-label" htmlFor="location">{language[lang].location}</label>
                                            <input
                                                id="location"
                                                type="text"
                                                name="location"
                                                className="form-control"
                                                placeholder={language[lang].location_placeholder}
                                                value={dados.current.contacts[0].location}
                                                onChange={handle_change_addresses} 
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-4 mb-3 d-none">
                                            <label className="form-label" htmlFor="username">{language[lang].username}*</label>
                                            <input
                                                id="username"
                                                type="text"
                                                name="username"
                                                className="form-control"
                                                placeholder={language[lang].username_placeholder}
                                                //value={dados.current.info.username !== '' ? dados.current.info.username : null}
                                                value={dados.current.info.username}
                                                //onChange={handle_change_info}
                                                onChange={e => set_dados(dados.current.info.username = e)} 
                                                readOnly={true}
                                                disabled
                                                required
                                            />
                                        </div>
                                        <div className="col-12 col-md-4 mb-3">
                                            <label className="form-label" htmlFor="email">{language[lang].email}*</label>
                                            <input 
                                                id="email"
                                                type="email" 
                                                pattern={pattern_email}
                                                name="email"
                                                value={dados.current.info.email}
                                                className="form-control"
                                                placeholder={language[lang].email_placeholder}
                                                //onChange={handle_change_info}
                                                onBlur={handle_change_info}
                                                onChange={handle_change_info_2}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label" htmlFor="password">{language[lang].password}*</label>
                                            <input 
                                                id="password"
                                                type="password" 
                                                name="password" 
                                                value={new_password} 
                                                min="9"
                                                title="A password deve conter pelo menos 9 digitos alfa-númericos" 
                                                className="form-control" 
                                                placeholder={language[lang].password_placeholder} 
                                                onChange={handle_change_info_new_password} 
                                                autoComplete="off" 
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label" htmlFor="password_conf">{language[lang].password_conf}*</label>
                                            <input 
                                                id="password_conf"
                                                type="password" 
                                                name="password_conf" 
                                                defaultValue={confirm_password} 
                                                min="9" 
                                                className="form-control" 
                                                placeholder={language[lang].password_conf_placeholder} 
                                                onBlur={handle_change_password} 
                                                autoComplete="off" 
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)} />
                                                <label className="form-check-label" htmlFor="agree">{language[lang].agree_terms_conditions}</label>&nbsp;
                                                <a href={Hosts.WEB_SITE_URI + "terms-conditions"} target="_blank" rel="noreferrer">{language[lang].terms_conditions_link}</a>
                                            </div>
                                            <label className="small" htmlFor="agree">{language[lang].terms_conditions_required}</label>
                                        </div>
                                        <div className="col-12 mt-5">
                                            <Button disabled={!agree} color="primary">{language[lang].send}</Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer dados_config={dados_config} dados_navbar={dados_navbar} />
            </>
    );


}

export default RegisterFarmerForm;